<div *ngIf="sectionInfo.cardId == 'A'">
    <h2 class="webapp-title-secondary nomargin-bottom">{{sectionInfo.title}}</h2>
    <div class="flex-row between">
        <div class="medium-gray-title w75">{{sectionInfo.subtitle}}</div>
        <a href="javascript: void(0)" *ngIf="!allVisible && sectionInfo.array.length>rowsDisplayed" class="link see-more margin-top-1rem" (click)="allVisible = true">Ver todos</a>
        <a href="javascript: void(0)" *ngIf="allVisible" class="link see-less margin-top-1rem" (click)="allVisible = false">Ver menos</a>
    </div>

    <div class="post-list" *ngIf="sectionInfo.array">
        <div class="post-horizontal rounded" *ngFor="let item of getVisibleRows(sectionInfo.array)">
            <div>
                <div class="post-title">{{item.title}}</div>
                <p class="small-text">{{item.description}}</p>
                <a *ngIf="item.link" href="javascript: void(0)" (click)="openLink(item.link)">{{item.linkLabel}}</a>
            </div>
            <div class="post-image" *ngIf="item.imageUrl">
                <img [src]="item.imageUrl" alt="">
            </div>
        </div>
        <div class="center">
            <i class="fas fa-chevron-down pointer icon-sm icon-btn" *ngIf="!allVisible && sectionInfo.array.length>rowsDisplayed" (click)="allVisible = true"></i>
            <i class="fas fa-chevron-up pointer icon-sm icon-btn" *ngIf="allVisible" (click)="allVisible = false"></i>
        </div>
    </div>
</div>

<div class="post-list" *ngIf="sectionInfo.cardId == 'B'">
    <a href="javascript:void(0)" class="link post-horizontal" *ngFor="let item of sectionInfo.array">
      <div class="infos">
        <div class="post-title">{{item.title}}</div>
        <div class="post-date">{{item.description}}</div>
        <ul *ngIf="item.sublist">
            <li *ngFor="let ele of item.sublist">{{ele}}</li>
        </ul>
      </div>
      <div class="post-image-horiz"><img [src]="item.imageUrl" alt=""></div> <!-- (click)="goToUrl(item.link)" -->
    </a>
</div>